export const mainMenu = [
  {
    label: '賃貸居住用',
    icon: '/assets/img/ico_rent.png',
    status: 'enable',
    url: '',
    child: [
      {
        label: '物件一覧・コンバート',
        status: 'enable',
        url: 'https://manager.fudo-3.com/rent-list/rent-room-list',
      },
      {
        label: '高速送信',
        status: 'enable',
        url: 'https://manager.fudo-3.com/kss',
      },
      {
        label: '契約登録',
        status: 'enable',
        url: 'https://citynet-forms.fudo-3.com',
      },
      {
        label: 'ツール',
        status: 'enable',
        url: 'https://manager.fudo-3.com/tool/login',
      },
      {
        label: 'CRM',
        status: 'enable',
        url: 'https://manager.fudo-3.com/rent-crm',
      },
      {
        label: '顧客情報',
        status: 'hide',
        url: 'https://manager.fudo-3.com/rent-crm',
      },
      {
        label: 'ユーザーマスタ',
        status: 'enable',
        url: '',
        child: [
          {
            label: '元付業者',
            status: 'enable',
            url: 'https://manager.fudo-3.com/user/eacompany.index',
          },
          {
            label: '貸主',
            status: 'enable',
            url: 'https://manager.fudo-3.com/user/ksk.index/1',
          },
          {
            label: '所有者',
            status: 'enable',
            url: 'https://manager.fudo-3.com/user/ksk.index/2',
          },
          {
            label: '管理会社',
            status: 'enable',
            url: 'https://manager.fudo-3.com/user/ksk.index/3',
          },
          {
            label: '電気会社',
            status: 'enable',
            url: 'https://manager.fudo-3.com/user/lifeline.list/1',
          },
          {
            label: '水道会社',
            status: 'enable',
            url: 'https://manager.fudo-3.com/user/lifeline.list/2',
          },
          {
            label: 'ガス会社',
            status: 'enable',
            url: 'https://manager.fudo-3.com/user/lifeline.list/3',
          },
          {
            label: '保証会社',
            status: 'enable',
            url: 'https://manager.fudo-3.com/user/guarantor.index',
          },
          {
            label: '近隣施設',
            status: 'enable',
            url: 'https://manager.fudo-3.com/user/neighbor.index',
          },
        ],
      },
    ],
  },
  {
    label: '賃貸事業用',
    icon: '/assets/img/ico_tenant.png',
    status: 'disable',
    url: '',
    child: [
      {
        label: '物件一覧・コンバート',
        status: 'enable',
        url: 'https://manager.fudo-3.com/rent-biz-list',
      },
      {
        label: '重税・契約書一覧',
        status: 'enable',
        url: 'https://manager.fudo-3.com/rent-biz-contract',
      },
      {
        label: 'CRM',
        status: 'enable',
        url: 'https://manager.fudo-3.com/rent-biz-crm',
      },
    ],
  },
  {
    label: '売買',
    icon: '/assets/img/ico_sale.png',
    status: 'enable',
    url: '',
    child: [
      {
        label: '居住用物件一覧',
        status: 'enable',
        url: 'https://sale.fudo-3.com/list/residence',
      },
      {
        label: '事業・投資用物件一覧',
        status: 'enable',
        url: 'https://sale.fudo-3.com/list/investment',
      },
      {
        label: '重説・契約書一覧',
        status: 'disable',
        url: '',
      },
      {
        label: 'CRM',
        status: 'disable',
        url: '',
      },
    ],
  },
  {
    label: '店舗情報・設定',
    icon: '/assets/img/ico_shop.png',
    status: 'disable',
    url: 'https://manager.fudo-3.com/setting',
  },
  {
    label: 'ヘルプ',
    icon: '/assets/img/ico_help.png',
    status: 'enable',
    url: 'https://manager.fudo-3.com/support',
  },
  {
    label: '3FilmsAdmin',
    icon: '/assets/img/ico_admin.png',
    status: 'enable',
    url: '',
    child: [
      {
        label: '会社グループ',
        status: 'enable',
        url: 'https://manager.fudo-3.com/admin/groups',
      },
      {
        label: '会社',
        status: 'enable',
        url: 'https://manager.fudo-3.com/admin/companies',
      },
      {
        label: '店舗グループ',
        status: 'enable',
        url: 'https://manager.fudo-3.com/admin/u_shopgroups',
      },
      {
        label: '店舗',
        status: 'enable',
        url: 'https://manager.fudo-3.com/admin/u_shops/all',
      },
      {
        label: 'FTPアカウント(賃居)',
        status: 'enable',
        url: 'https://manager.fudo-3.com/admin/ftps',
      },
      {
        label: 'コンバート結果(賃居)',
        status: 'enable',
        url: 'https://manager.fudo-3.com/admin/convert/list/rent#/app/blank',
      },
      {
        label: 'FTPアカウント(賃事)',
        status: 'enable',
        url: 'https://manager.fudo-3.com/admin/biz/ftps',
      },
      {
        label: 'コンバート結果(賃事)',
        status: 'enable',
        url: 'https://manager.fudo-3.com/admin/convert/list/biz',
      },
    ],
  },
  {
    label: 'ログアウト',
    icon: '/assets/img/ico_logout.png',
    status: 'enable',
    url: 'https://manager.fudo-3.com/logout',
  },
]
